module.exports = __webpack_public_path__ + "static/media/brimstone.7841c20f.png";